module.exports = __webpack_public_path__ + "images/spinner.dd88566680cbf35fabbf.gif";